import { Controller } from "@hotwired/stimulus"

// Disabling a user cancels every subscription they hold in Stripe, so unticking
// "Enabled" asks first. Turbo shows the themed confirm dialog for any form that
// carries data-turbo-confirm; this only sets that attribute while the box is
// unticked on an account that was enabled.
export default class extends Controller {
  static targets = ["enabled"]
  static values = { message: String }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasEnabledTarget || !this.messageValue) return

    if (this.enabledTarget.checked) {
      delete this.element.dataset.turboConfirm
    } else {
      this.element.dataset.turboConfirm = this.messageValue
    }
  }
}
